import { GetFeatureFlagSetResponse } from "../../api";

export const INIT_DATA = "INIT_DATA" as const;
export const LOAD_FEATURE_FLAG = "@@FeatureFlags/LOAD_FEATURE_FLAG" as const;
export const LOAD_FEATURE_FLAG_SUCCESS = "@@FeatureFlags/LOAD_FEATURE_FLAG_SUCCESS" as const;
export const LOAD_FEATURE_FLAG_FAILED = "@@FeatureFlags/LOAD_FEATURE_FLAG_FAILED" as const;

type LoadFeatureFlagPayload = { route: string; partnerCode: string };

export const initializeData = () => ({ type: INIT_DATA } as const);

export const loadFeatureFlag = (payload: LoadFeatureFlagPayload) =>
  ({
    type: LOAD_FEATURE_FLAG,
    payload,
  } as const);

export const loadFeatureFlagSuccess = (payload: GetFeatureFlagSetResponse) =>
  ({
    type: LOAD_FEATURE_FLAG_SUCCESS,
    payload,
  } as const);

export const loadFeatureFlagFailed = (payload: any) => ({ type: LOAD_FEATURE_FLAG_FAILED, payload } as const);

export type FeatureFlagAction =
  | ReturnType<typeof initializeData>
  | ReturnType<typeof loadFeatureFlag>
  | ReturnType<typeof loadFeatureFlagSuccess>
  | ReturnType<typeof loadFeatureFlagFailed>;
